export default __webpack_public_path__ + "static/media/category-2.5844a4c5.svg";